/**
 * @description IOS Device
 */
export enum IOSDevice {
	IPAD = 'iPad',
	IPHONE = 'iPhone'
}